import React, { Component } from 'react';
import Loading from '../../shared/Loading';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import NewGeneralFaq from '.';
// import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const query = gql`
  query getGeoLocation {
    ipLocationInformation {
      countryCode
      stateCode
      cityCode
    }
  }
`;

const GetLocation = () => {
  return (
    <Query query={query}>
      {({ loading, error, data, refetch }) => {
        console.log(data);

        if (loading)
          return (
            <div className="load-div">
              <Loading size="3x" />
            </div>
          );
        if (data.ipLocationInformation) {
          return (
            <NewGeneralFaq
              country={data.ipLocationInformation.countryCode}
            />
          );
        }
      }}
    </Query>
  );
};

export default GetLocation;

// class GeoRouter extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render() {
//     const { loggedIn } = this.props;
//     return (
//       <Query query={query}>
//         {({ loading, error, data, refetch }) => {
//           console.log(data);

//           if (loading)
//             return (
//               <div className="load-div">
//                 <Loading size="3x" />
//               </div>
//             );
//           if (data.ipLocationInformation) {
//             if (data.ipLocationInformation.countryCode === 'US') {
//               if (data.ipLocationInformation.stateCode === 'CA') {
//                 return <Redirect to="sf" />;
//               } else {
//                 return <Redirect to="nyc" />;
//               }
//             } else {
//               return <Redirect to="toronto" />;
//             }
//           }
//         }}
//       </Query>
//     );
//   }
// }

// export default GeoRouter;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/GetLocation.js